var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.lists),function(list){return _c('List',{key:list.title,staticClass:"mb-3 mb-md-4",attrs:{"list":list}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }